const DropdownView = (SetDesign, $) => {
    const { addAction } = SetDesign;
    const { doAction } = SetDesign;
    const $container = $('.sd-ss');
    const isSingle = $container.hasClass('sd-ss--single');
    if (!$container.length) {
        return false;
    }

    const { services, svg: svgUrl } = window.sdssVars;
    const $menuToggle = $container.find('.sd-ss__toggle');
    const $serviceLinks = $container.find('.sd-ss__service-list__link');
    const $serviceList = $container.find('.sd-ss__service-list');
    const $ctaButton = $container.find('.sd-ss__button');
    const ogCta = $ctaButton.attr('href');
    const $embedTarget = $container.find('.sd-ss__embed');
    const ogEmbed = $embedTarget.html();
    const activeClass = 'sd-ss__embed--active';
    let toggleNav;

    const onEsc = (e) => {
        if (e.keyCode === 27) {
            toggleNav();
        }
    };

    toggleNav = (e) => {
        if (e) {
            e.preventDefault();
        }

        $container.toggleClass('sd-ss--open');
        const isOpen = $container.hasClass('sd-ss--open');
        $menuToggle.attr('aria-expanded', isOpen);
        $serviceList.attr('aria-hidden', !isOpen);

        if (isOpen) {
            $serviceLinks.removeAttr('tabindex');
            $container.on('keyup', onEsc);
        } else {
            $container.off('keyup', onEsc);
            $serviceLinks.attr('tabindex', -1);
            $menuToggle.focus();
        }

        doAction('stream-selector/toggleNav', isOpen);
    };

    function onServiceSelect(e) {
        if (e) {
            e.preventDefault();
        }

        const selected = $(this).data('targetId');
        if (services.hasOwnProperty(selected)) {
            $embedTarget.addClass('sd-ss__embed--loading');

            if (!isSingle) {
                toggleNav();
            }

            $ctaButton.attr('href', services[selected].link || ogCta);
            $embedTarget.css('padding-top', '');
            $embedTarget.removeClass(activeClass);
            $embedTarget.html(services[selected].embed);
            const childHeight = $embedTarget.children().height();
            const childWidth = $embedTarget.children().width();
            const padding = (childHeight / childWidth) * 100;
            $embedTarget.css('padding-top', `${padding}%`);
            $embedTarget.addClass(activeClass);
            doAction('stream-selector/select', services[selected].label);
            $embedTarget.find('iframe').on('load', () => {
                $embedTarget.removeClass('sd-ss__embed--loading');
            });
        }
    }

    const loadSvgs = (url) => {
        $.get(url, (data) => {
            const div = document.createElement('div');
            div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
            document.body.insertBefore(div, document.body.childNodes[0]);
        });
    };

    const resetState = () => {
        $embedTarget.css('padding-top', '').removeClass(activeClass).html(ogEmbed);
        $ctaButton.attr('href', ogCta);

        if (isSingle) {
            onServiceSelect.call($serviceLinks[0], null);
        }
    };

    addAction('componentReset', resetState);
    addAction(SetDesign.HASH_STATE_CHANGE, resetState);

    if (isSingle) {
        onServiceSelect.call($serviceLinks[0], null);
    } else {
        loadSvgs(svgUrl);
        $menuToggle.click(toggleNav);
        $serviceLinks.click(onServiceSelect);
    }

    addAction('stream-selector/switch-to-index', (index) => {
        onServiceSelect.call($serviceLinks[index], null);
        toggleNav();
    });
    return doAction('stream-selector/loaded', $container);
};

export default DropdownView;
